document.addEventListener('DOMContentLoaded', () => {
  let productFormButtons = Array.from(document.querySelectorAll('.product-form__buttons'));
  if (productFormButtons.length === 0) {
    productFormButtons = Array.from(document.querySelectorAll('.subscription-flow__trigger'));
  }
  const stickyAtc = document.querySelector('.sticky-atc-wrapper');
  const stickyButton = stickyAtc?.querySelector('button');

  if (productFormButtons.length === 0 || !stickyAtc) return;

  let isStickyVisible = false;
  let debounceTimeout;
  let blockStickyAtc = false;

  function areButtonsOutOfView() {
    for (const button of productFormButtons) {
      const { top, bottom } = button.getBoundingClientRect();
      if (bottom > 0 && top > 0) {
        return false;
      }
    }
    return true;
  }

  function handleStickyAtc() {
    if (blockStickyAtc) return;
    const shouldShowSticky = areButtonsOutOfView();
    if (shouldShowSticky !== isStickyVisible) {
      stickyAtc.classList.toggle('visible', shouldShowSticky);
      isStickyVisible = shouldShowSticky;
    }
  }

  function debounceScrollHandler() {
    if (debounceTimeout) cancelAnimationFrame(debounceTimeout);
    debounceTimeout = requestAnimationFrame(handleStickyAtc);
  }
  window.addEventListener('scroll', debounceScrollHandler);
  window.addEventListener('resize', debounceScrollHandler);

  stickyButton.addEventListener('click', (event) => {
    event.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });

  handleStickyAtc();
});
